// removed by extract-text-webpack-plugin
module.exports = {"arrow":"arrow___1nIJa","root":"root___3-zQ2","top":"top___3-fJ0","right":"right___R4PqV","left":"left___1K4ly","bottom":"bottom___7f9Qo","correct":"correct___2FLi-","wrong":"wrong___1kVgr","brand":"brand___1KYGm","accent":"accent___1yPqd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InlineTooltip/index.scss
// module id = 87
// module chunks = 0